import {
  ActionIcon,
  Badge,
  Button,
  Card,
  createTheme,
  Drawer,
  MantineColorsTuple,
  Modal,
  Paper,
  Table,
  Tooltip,
} from '@mantine/core';

/** Deep cerulean: calm and clinical, distinct from the green/red used for status. */
const brand: MantineColorsTuple = [
  '#e6f5fa',
  '#d2e8f0',
  '#a6cfdf',
  '#77b5ce',
  '#509fbf',
  '#3791b6',
  '#278ab3',
  '#16779d',
  '#056a8d',
  '#005c7c',
];

const fontFamily = "'Inter Variable', Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: { light: 7, dark: 5 },
  colors: { brand },
  fontFamily,
  fontFamilyMonospace: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  headings: { fontFamily, fontWeight: '650' },
  defaultRadius: 'md',
  cursorType: 'pointer',
  components: {
    Button: Button.extend({ defaultProps: { radius: 'md' } }),
    ActionIcon: ActionIcon.extend({ defaultProps: { variant: 'subtle', radius: 'md' } }),
    Card: Card.extend({ defaultProps: { withBorder: true, radius: 'lg', padding: 'lg' } }),
    Paper: Paper.extend({ defaultProps: { radius: 'lg' } }),
    Badge: Badge.extend({ defaultProps: { variant: 'light', radius: 'sm' } }),
    Table: Table.extend({ defaultProps: { verticalSpacing: 'sm', highlightOnHover: true } }),
    Tooltip: Tooltip.extend({ defaultProps: { withArrow: true, openDelay: 250 } }),
    Modal: Modal.extend({ defaultProps: { radius: 'lg', centered: true, overlayProps: { backgroundOpacity: 0.45, blur: 2 } } }),
    Drawer: Drawer.extend({ defaultProps: { position: 'right', size: 'lg', overlayProps: { backgroundOpacity: 0.35, blur: 1 } } }),
  },
});
